import React, { useState } from "react";

const services = [
  {
    num: "01",
    emoji: "🤸",
    name: "Thai Sports Massage",
    price: "From ₹3,000",
    duration: "60 Min · 90 Min",
  },
  {
    num: "02",
    emoji: "🌊",
    name: "Swedish Massage",
    price: "From ₹2,000",
    duration: "60 Min · 90 Min",
  },
  {
    num: "03",
    emoji: "🪨",
    name: "Hot Stone Massage",
    price: "From ₹3,500",
    duration: "60 Min · 90 Min",
  },
  {
    num: "04",
    emoji: "👑",
    name: "Royal H2O Signature",
    price: "From ₹4,000",
    duration: "120 Min · 180 Min",
  },
  {
    num: "05",
    emoji: "🌺",
    name: "Aroma Therapy",
    price: "From ₹2,000",
    duration: "60 Min · 90 Min",
  },
  {
    num: "06",
    emoji: "💆",
    name: "Deep Tissue Massage",
    price: "From ₹3,000",
    duration: "60 Min · 90 Min",
  },
  {
    num: "07",
    emoji: "🌴",
    name: "Balinese Massage",
    price: "From ₹2,500",
    duration: "60 Min · 90 Min",
  },
  {
    num: "08",
    emoji: "🕯️",
    name: "Warm Candle Massage",
    price: "From ₹3,500",
    duration: "60 Min",
  },
];

function Booking() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    date: "",
    time: "",
  });
  const [sent, setSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    const message = `New Appointment Request:
  Name: ${form.name}
  Phone: ${form.phone}
  Email: ${form.email}
  Service: ${form.service}
  Date: ${form.date}
  Time: ${form.time}`;

    const whatsappNumber = "919521713060"; // Your number with country code

    window.open(
      `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  return (
    <section className="booking-section" id="contact">
      <div className="booking-grid">
        <div className="reveal-left">
          <div className="section-label" style={{ color: "var(--gold)" }}>
            Make An Appointment
          </div>
          <h2 className="booking-title">
            Relax Anytime,
            <br />
            <em>Any Day</em>
          </h2>
          <p className="booking-desc">
            Experience 20% off your first visit. Our serene sanctuary awaits you
            — book your session now and let us restore your body and soul.
          </p>
          <div className="contact-info">
            {[
              { icon: "📞", text: "+91 9521713060" },
              {
                icon: "📍",
                text: "4th Floor, Hotel Avantika Palace, Kanti Chandra Rd, Hathi Babu ka Bagh, Polovictory, Sindhi Camp, Jaipur, Rajasthan 302006",
              },
            ].map((c) => (
              <div className="contact-item" key={c.text}>
                <div className="contact-icon">{c.icon}</div>
                <span>{c.text}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="reveal-right" style={{ transitionDelay: ".15s" }}>
          <form className="booking-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Full Name</label>
                <input
                  className="form-input"
                  placeholder="Your name"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  required
                />
              </div>
              <div className="form-group">
                <label className="form-label">Phone</label>
                <input
                  className="form-input"
                  placeholder="+91 XXXXX XXXXX"
                  value={form.phone}
                  onChange={(e) => setForm({ ...form, phone: e.target.value })}
                />
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Email Address</label>
              <input
                className="form-input"
                type="email"
                placeholder="your@email.com"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label className="form-label">Select Service</label>
              <select
                className="form-select"
                value={form.service}
                onChange={(e) => setForm({ ...form, service: e.target.value })}
              >
                <option value="">Choose a treatment</option>
                {services.map((s) => (
                  <option key={s.name} value={s.name}>
                    {s.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Preferred Date</label>
                <input
                  className="form-input"
                  type="date"
                  value={form.date}
                  onChange={(e) => setForm({ ...form, date: e.target.value })}
                />
              </div>
              <div className="form-group">
                <label className="form-label">Preferred Time</label>
                <select
                  className="form-select"
                  value={form.time}
                  onChange={(e) => setForm({ ...form, time: e.target.value })}
                >
                  <option value="">Select time</option>
                  {[
                    "10:00 AM",
                    "11:00 AM",
                    "12:00 PM",
                    "1:00 PM",
                    "2:00 PM",
                    "3:00 PM",
                    "4:00 PM",
                    "5:00 PM",
                    "6:00 PM",
                    "7:00 PM",
                    "8:00 PM",
                  ].map((t) => (
                    <option key={t} value={t}>
                      {t}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <button
              type="submit"
              className="btn-primary"
              style={{ marginTop: "8px", width: "100%", padding: "16px" }}
            >
              {sent ? "✓ Appointment Requested!" : "Book My Appointment"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}

export default Booking;
